import { EorderWizardStep, EorderWizardState } from '../../models/eorder-wizard-state';

export abstract class WizardPageContent {
	readonly stepIndex: EorderWizardStep;
	constructor(stepIndex: EorderWizardStep, state: EorderWizardState) {
		this.stepIndex = stepIndex;
		state.errorInPage = false;
	}
	abstract checkError(): boolean;

	abstract checkErrorForDraft(): boolean;
}
